/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import Loader from "react-loader";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
} from "@material-ui/core";
import ReactExport from "react-export-excel";

// components
import MainLayout from "../../components/hoc/MainLayout";
import { apiGet } from "../../helpers/api";
import displayName from "../../helpers/displayName";
import TypeFilter from "../../components/TypeFilter";

const useStyles = makeStyles((theme) => ({
  table: { minWidth: 650 },
  noResults: { fontStyle: "italic", color: "#b99d9d" },
  exportButton: {
    verticalAlign: "bottom",
    marginLeft: "10px",
    marginBottom: "10px",
  },
  searchButton: {
    verticalAlign: "bottom",
    marginLeft: "10px",
    marginBottom: "10px",
  },
}));

function DeliveriesSummary(props) {
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const classes = useStyles();
  const [data, setData] = useState(null);
  const [orderType, setOrderType] = useState("");

  const fetchData = useCallback(async () => {
    // get data from api
    try {
      let url = `/reports/deliveries_summary`;
      if (orderType !== "") {
        url += `?type=${orderType}`;
      }
      setData(null);
      const response = await apiGet(url);
      setData(response.data);
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  }, [orderType]);

  useEffect(() => {
    fetchData();
  }, []);

  let total = 0;
  const sData = data?.map((row) => {
    total += row.total;
    return {
      name: displayName(row.store?.firstName, row.store?.lastName),
      email: row.store?.email,
      mobile: row.store?.mobileNumber,
      total: row.total.toLocaleString(),
    };
  });

  sData?.push({
    name: "TOTAL",
    total: total.toLocaleString(),
  });

  return (
    <Loader loaded={data !== null}>
      <Typography variant="h5" gutterBottom style={{ verticalAlign: "bottom" }}>
        Deliveries Summary
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TypeFilter
            value={orderType}
            onChange={(e) => setOrderType(e.target.value)}
          />

          <Button
            variant="contained"
            onClick={fetchData}
            className={classes.searchButton}
          >
            Search
          </Button>
          <ExcelFile
            element={
              <Button
                variant="contained"
                className={classes.exportButton}
                disabled={data?.length === 0}
              >
                Export
              </Button>
            }
            filename="deliveries-summary"
          >
            <ExcelSheet data={sData} name="Stores">
              <ExcelColumn label="Name" value="name" />
              <ExcelColumn label="Email" value="email" />
              <ExcelColumn label="Mobile" value="mobile" />
              <ExcelColumn label="Total" value="total" />
            </ExcelSheet>
          </ExcelFile>
        </div>
      </Typography>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Store</TableCell>
              <TableCell align="left">Email</TableCell>
              <TableCell align="left">Mobile #</TableCell>
              <TableCell align="left">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={4}>
                  <span className={classes.noResults}>No results found</span>
                </TableCell>
              </TableRow>
            )}
            {data?.map((row) => {
              return (
                <TableRow
                  key={row.store.email}
                  style={{ verticalAlign: "top" }}
                >
                  <TableCell align="left">
                    {displayName(row.store?.firstName, row.store?.lastName)}
                  </TableCell>
                  <TableCell align="left">{row.store?.email}</TableCell>
                  <TableCell align="left">{row.store?.mobileNumber}</TableCell>
                  <TableCell align="left">
                    {row.total.toLocaleString()}
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell colSpan={3} style={{ fontWeight: "bold" }}>
                TOTAL
              </TableCell>
              <TableCell align="left" style={{ fontWeight: "bold" }}>
                {total.toLocaleString()}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Loader>
  );
}

export default MainLayout(DeliveriesSummary);
